@let containerWidth = scrollContainer.offsetWidth;
@let calculatedMaxHeight = thresholdItems() && childItemHeight() ? childItemHeight() * thresholdItems() : (containerWidth > 600 ? (childItemHeight() || 40) * 8 : (childItemHeight() || 40) * 6);
@let containerMaxHeight = maxHeight() || calculatedMaxHeight;
<section
  #scrollContainer
  class="custom-scrollbar h-fit w-full border-solid bg-transparent border-border-solid"
  [ngStyle]="{ 
    'max-height': (withBorder ? containerMaxHeight + 2 : containerMaxHeight) + 'px',
    'min-height': minHeight() + 'px',
  }"
  [ngClass]="{
  'overflow-hidden': _disabled,
  'overflow-y-auto': scrollDirection === 'vertical' && !_disabled,
  'overflow-x-auto': scrollDirection === 'horizontal' && !_disabled,
  'overflow-auto': scrollDirection === 'both' && !_disabled,
  'border-1 border-radius-8 focus-visible:outline-primary' : withBorder,
  'focus:outline-none': !withBorder,
  'with-divider': withDivider,
  }"
  (scroll)="onScroll($event)"
>
  <ng-content></ng-content>
</section>
